import React from 'react'
import Aboutme from '../component/Aboutme'

const About = () => {
  return (
    <div >
      <Aboutme />
    </div>
  )
}

export default About
